// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/flight-plan-flight-rule-codes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/flight-plan-flight-rule-codes/flight-plan-flight-rule-codes.js';

mount([g0]);
